(function(){"use strict";try{if(typeof document<"u"){var t=document.createElement("style");t.appendChild(document.createTextNode(".or-toast__link[data-v-2e3acf16]{word-break:break-word;white-space:nowrap;cursor:pointer}.or-toast--transition-slide-enter-active[data-v-26edc04e],.or-toast--transition-slide-leave-active[data-v-26edc04e]{transition:transform .4s ease}.or-toast--transition-slide-enter-from.or-toast--position-right[data-v-26edc04e],.or-toast--transition-slide-leave-to.or-toast--position-right[data-v-26edc04e]{transform:translate(999px)}.or-toast--transition-slide-enter-from.or-toast--position-left[data-v-26edc04e],.or-toast--transition-slide-leave-to.or-toast--position-left[data-v-26edc04e]{transform:translate(-999px)}.or-toast--transition-fade-enter-active[data-v-26edc04e],.or-toast--transition-fade-leave-active[data-v-26edc04e]{transition:opacity .4s ease}.or-toast--transition-fade-enter-from[data-v-26edc04e],.or-toast--transition-fade-leave-to[data-v-26edc04e]{opacity:0}")),document.head.appendChild(t)}}catch(e){console.error("vite-plugin-css-injected-by-js",e)}})();
import { createSharedComposable as Y, useEventBus as $, useToggle as G, noop as Q } from "@vueuse/core";
import { defineComponent as N, ref as _, computed as f, resolveComponent as A, openBlock as h, createElementBlock as b, normalizeClass as C, renderSlot as X, createVNode as D, createCommentVNode as I, createElementVNode as U, toDisplayString as J, createBlock as B, withModifiers as K, onBeforeMount as W, onBeforeUnmount as Z, nextTick as x, withCtx as M, TransitionGroup as ee, Fragment as te, renderList as oe, mergeProps as se } from "vue";
import { useElevation as re } from "@onereach/ui-components-common/hooks";
import { O as ne } from "./OrTeleport.vue3-C9kW_8PS.mjs";
import { error as ae, success as ie } from "@onereach/ui-components-common/assets";
import { O as le } from "./OrIconButton-BlHCLpeW.mjs";
import { O as ue } from "./OrLoader-2SaTMxmZ.mjs";
import { _ as P } from "./_plugin-vue_export-helper-CHgC5LLL.mjs";
var L = /* @__PURE__ */ ((e) => (e.Right = "right", e.Left = "left", e.Center = "center", e))(L || {}), w = /* @__PURE__ */ ((e) => (e.Top = "top", e.Bottom = "bottom", e))(w || {}), E = /* @__PURE__ */ ((e) => (e.Slide = "slide", e.Fade = "fade", e))(E || {}), y = /* @__PURE__ */ ((e) => (e.Success = "success", e.Error = "error", e.Loading = "loading", e))(y || {});
const He = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  PositionsX: L,
  PositionsY: w,
  ToastType: y,
  TransitionType: E
}, Symbol.toStringTag, { value: "Module" })), ce = [
  // Layout
  "layout-row",
  // Box
  "w-[343px] md:w-[512px]",
  // Shape
  "rounded-md",
  // Spacing
  "px-md",
  "py-md",
  "gap-md",
  // Typography
  "typography-caption-regular",
  // Elevation
  "shadow-card",
  "dark:shadow-card-dark",
  // Theme
  "theme-background-surface-inverse",
  "dark:theme-background-surface-inverse-dark",
  "theme-foreground-on-surface-inverse",
  "dark:theme-foreground-on-surface-inverse-dark",
  // Theme (children)
  "[&_:any-link]:text-inverse-primary",
  "dark:[&_:any-link]:text-inverse-primary-dark"
], de = [
  // Position
  "absolute",
  // Layout
  "layout-column",
  // Spacing
  "gap-sm",
  // Overflow
  "overflow-hidden"
], me = {
  "left-top": [
    // Position
    "left-md md:left-lg",
    "top-md md:top-lg"
  ],
  "center-top": [
    // Position
    "top-md md:top-lg"
  ],
  "right-top": [
    // Position
    "right-md md:right-lg",
    "top-md md:top-lg"
  ],
  "left-bottom": [
    // Position
    "left-md md:left-lg",
    "bottom-md md:bottom-lg"
  ],
  "center-bottom": [
    // Position
    "bottom-md md:bottom-lg"
  ],
  "right-bottom": [
    // Position
    "right-md md:right-lg",
    "bottom-md md:bottom-lg"
  ]
}, pe = {
  success: [
    // Typography
    "typography-caption-regular"
  ],
  error: [
    // Typography
    "typography-caption-regular"
  ],
  loading: [
    // Typography
    "typography-caption-regular"
  ]
}, fe = N({
  name: "OrToast",
  components: {
    OrIconButton: le,
    OrLoader: ue
  },
  props: {
    toastType: {
      type: String,
      default: () => y.Success
    },
    link: {
      type: Object,
      default: void 0
    },
    messageText: {
      type: String,
      default: void 0
    },
    dismissible: {
      type: Boolean,
      default: !0
    }
  },
  emits: [
    "close"
  ],
  expose: [
    "root"
  ],
  setup(e, t) {
    const r = _(), u = f(() => [
      ...ce
    ]), g = f(() => [
      "self-center",
      "object-cover",
      // Box
      "w-[20px]",
      "h-[20px]"
    ]), d = f(() => [
      ...pe[e.toastType],
      "grow"
    ]), a = f(() => [
      //Layout
      "self-center",
      // Theme
      "text-inverse-primary",
      "dark:text-inverse-primary-dark"
    ]), n = f(() => {
      switch (e.toastType) {
        case y.Success:
          return ie;
        case y.Error:
          return ae;
        default:
          return null;
      }
    }), s = f(() => {
      var v;
      return ((v = e.link) == null ? void 0 : v.target) ?? "_self";
    });
    function l() {
      t.emit("close");
    }
    function m(v) {
      var k, T, c;
      (k = e.link) != null && k.callback && (v.preventDefault(), (c = (T = e.link).callback) == null || c.call(T));
    }
    return {
      root: r,
      toastIconStyle: g,
      rootStyles: u,
      loaderStyle: a,
      messageStyle: d,
      emojiSrc: n,
      hrefTarget: s,
      onClose: l,
      onLinkClick: m
    };
  }
}), he = ["src"], ge = ["innerHTML"], ve = {
  class: /* @__PURE__ */ C(["layout-row", "self-start", "gap-md"])
}, ye = ["href", "target"];
function ke(e, t, r, u, g, d) {
  const a = A("OrLoader"), n = A("OrIconButton");
  return h(), b("div", {
    ref: "root",
    class: C(e.rootStyles)
  }, [
    X(e.$slots, "content", {}, () => [
      e.toastType === "loading" ? (h(), b("div", {
        key: 0,
        class: C(e.loaderStyle)
      }, [
        D(a, {
          variant: "circular",
          color: "inherit",
          size: "s"
        })
      ], 2)) : e.emojiSrc ? (h(), b("img", {
        key: 1,
        class: C(e.toastIconStyle),
        src: e.emojiSrc,
        alt: "Emoji"
      }, null, 10, he)) : I("", !0),
      e.messageText ? (h(), b("div", {
        key: 2,
        class: C(e.messageStyle),
        innerHTML: e.messageText
      }, null, 10, ge)) : I("", !0)
    ], !0),
    U("div", ve, [
      e.link ? (h(), b("a", {
        key: 0,
        class: "or-toast__link",
        href: e.link.href,
        target: e.hrefTarget,
        onClick: t[0] || (t[0] = (...s) => e.onLinkClick && e.onLinkClick(...s))
      }, J(e.link.title), 9, ye)) : I("", !0),
      e.dismissible ? (h(), B(n, {
        key: 1,
        icon: "close",
        size: "m",
        onClick: t[1] || (t[1] = K((s) => e.onClose(), ["stop"]))
      })) : I("", !0)
    ])
  ], 2);
}
const Te = /* @__PURE__ */ P(fe, [["render", ke], ["__scopeId", "data-v-2e3acf16"]]);
function be(e) {
  const t = _(e || []);
  return {
    queue: t,
    addItem: (a) => {
      const n = _(a);
      t.value.push(n);
    },
    removeItem: (a) => {
      const n = t.value.findIndex((s, l, m) => a == null ? void 0 : a(s.value, l, m));
      n !== -1 && t.value.splice(n, 1);
    },
    clearAll: () => {
      t.value = [];
    },
    getItem: (a) => t.value.filter((n, s, l) => a == null ? void 0 : a(n.value, s, l))[0]
  };
}
const Ce = () => {
  const e = {
    toastNotify: $("toastNotify"),
    toastClose: $("toastClose"),
    toastCloseAll: $("toastCloseAll"),
    toastUpdate: $("toastUpdate")
  };
  return {
    on: (t, r) => {
      e[t].on(r);
    },
    off: (t, r) => {
      e[t].off(r);
    },
    emit: (t, r) => {
      e[t].emit(r);
    }
  };
}, q = Y(Ce), Se = N({
  name: "OrToastContainer",
  components: {
    OrTeleport: ne,
    OrToast: Te
  },
  props: {
    includeHeaderHeight: {
      type: Boolean,
      default: !0
    },
    position: {
      type: Object,
      default: {
        positionX: L.Right,
        positionY: w.Bottom
      }
    },
    transition: {
      type: String,
      default: () => E.Slide
    }
  },
  setup(e) {
    const t = _(), { on: r, off: u } = q(), { queue: g, addItem: d, removeItem: a, clearAll: n, getItem: s } = be(), [l, m] = G(!1), v = f(() => {
      var o;
      return [
        "or-toast-container-v3",
        ...de,
        ...me[`${e.position.positionX}-${e.position.positionY}`],
        {
          "position--top--with-header": ((o = e.position) == null ? void 0 : o.positionY) === w.Top && e.includeHeaderHeight
        }
      ];
    }), k = f(() => {
      var o;
      return `or-toast--position-${(o = e.position) == null ? void 0 : o.positionX} or-toast--transition-${e.transition}`;
    }), T = f(() => g.value.map(({ value: o }) => o));
    function c(o) {
      const i = () => {
        var p;
        d(o), (p = o.timer) == null || p.start(
          O.bind(null, o),
          o.toastBehaviour.duration
        );
      };
      l.value ? i() : (m(!0), x(i));
    }
    function S(o) {
      const i = s((p) => p.hash === o.hash);
      i && (i.value = o);
    }
    function O(o) {
      a((i) => {
        var p, j, H;
        return i.hash === o.hash ? ((j = (p = i.toastBehaviour) == null ? void 0 : p.onToastClose) == null || j.call(p), (H = i.timer) == null || H.stop(), !0) : !1;
      });
    }
    function z(o) {
      var i;
      o.toastBehaviour.pauseOnHover && ((i = o.timer) == null || i.pause());
    }
    function R(o) {
      var i;
      o.toastBehaviour.pauseOnHover && ((i = o.timer) == null || i.resume());
    }
    function V(o) {
      var i;
      (i = o.onToastClick) == null || i.call(o);
    }
    function F() {
      m(T.value.length > 0);
    }
    return W(() => {
      r("toastNotify", c), r("toastClose", O), r("toastUpdate", S), r("toastCloseAll", n);
    }), Z(() => {
      u("toastNotify", c), u("toastClose", O), u("toastUpdate", S), u("toastCloseAll", n);
    }), re(t, l), {
      on: r,
      off: u,
      classes: v,
      transitionName: k,
      isActive: l,
      toggle: m,
      addItem: d,
      removeItem: a,
      clearAll: n,
      getItem: s,
      queue: T,
      root: t,
      createToast: c,
      toastUpdate: S,
      toastRemove: O,
      onToastEnter: z,
      onToastLeave: R,
      onClick: V,
      onToastHidden: F
    };
  }
});
function Oe(e, t, r, u, g, d) {
  const a = A("OrToast"), n = A("OrTeleport");
  return h(), B(n, { disabled: e.isActive }, {
    default: M(() => [
      U("div", {
        ref: "root",
        class: C(e.classes)
      }, [
        D(ee, {
          name: e.transitionName,
          tag: "div",
          class: "contents",
          onAfterLeave: e.onToastHidden
        }, {
          default: M(() => [
            (h(!0), b(te, null, oe(e.queue, (s) => (h(), B(a, se(s.toastProps, {
              key: s.hash,
              onClick: (l) => e.onClick(s.toastBehaviour),
              onMouseenter: (l) => e.onToastEnter(s),
              onMouseleave: (l) => e.onToastLeave(s),
              onClose: (l) => e.toastRemove(s)
            }), null, 16, ["onClick", "onMouseenter", "onMouseleave", "onClose"]))), 128))
          ]),
          _: 1
        }, 8, ["name", "onAfterLeave"])
      ], 2)
    ]),
    _: 1
  }, 8, ["disabled"]);
}
const Me = /* @__PURE__ */ P(Se, [["render", Oe], ["__scopeId", "data-v-26edc04e"]]);
class $e {
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  constructor() {
    this.startedAt = null, this.timer = null, this.callback = Q, this.delay = 0;
  }
  start(t, r) {
    r && r > 0 && (this.callback = t, this.delay = r, this.startedAt = Date.now(), this.timer = setTimeout(this.callback, this.delay));
  }
  pause() {
    this.timer && this.startedAt && (this.stop(), this.delay -= Date.now() - this.startedAt);
  }
  resume() {
    this.stop(), this.delay > 0 && (this.startedAt = Date.now(), this.timer = setTimeout(this.callback, this.delay));
  }
  stop() {
    this.timer && clearTimeout(this.timer);
  }
}
function Ne(e = {}) {
  const { emit: t } = q();
  function r(n, s = {}) {
    const { duration: l = 5e3, pauseOnHover: m = !0, onToastClose: v, onToastClick: k } = s, c = {
      toastProps: {
        ...n,
        ...e
      },
      //generate ToastHash
      hash: Math.random().toString(36).slice(2),
      ...Number.isInteger(l) && { timer: new $e() },
      toastBehaviour: {
        duration: l,
        pauseOnHover: m,
        onToastClose: v,
        onToastClick: k
      }
    };
    return t("toastNotify", c), {
      close: () => t("toastClose", c),
      update: (S) => t("toastUpdate", {
        ...c,
        toastProps: {
          ...c.toastProps,
          ...S
        }
      })
    };
  }
  function u() {
    t("toastCloseAll");
  }
  function g(n, s = {}) {
    return r({
      ...n,
      toastType: y.Success
    }, s);
  }
  function d(n, s = {}) {
    return r({
      ...n,
      toastType: y.Error
    }, s);
  }
  function a(n, s = {}) {
    return r({
      dismissible: !1,
      ...n,
      toastType: y.Loading
    }, {
      ...s,
      duration: 0
      // <- toast with type "loading" will not cloe automatically
    });
  }
  return {
    notify: r,
    clearAll: u,
    success: g,
    error: d,
    loading: a
  };
}
const De = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null
}, Symbol.toStringTag, { value: "Module" }));
export {
  Te as O,
  Me as a,
  be as b,
  He as p,
  De as t,
  Ne as u
};
//# sourceMappingURL=types-BwxhurSS.mjs.map
